module.exports = __webpack_public_path__ + "static/media/vector-bg.dad7b823.png";